import Box from '@/primitives/Box'
import Card from '@/primitives/Card'
import FlexV2 from '@/primitives/FlexV2'
import Grid from '@/primitives/Grid'
import Text from '@/primitives/Text'
import MetricValue from './MetricValue'
import Slot from '@/primitives/Slot'
import Loader from '@/primitives/Loader'
import { useLiveData } from '../../hooks/useLiveData'

const LiveView = ({
  metrics,
  sectionA,
  sectionB,
  trial,
  type = 'envirosense'
}) => {
  const sectionAName = sectionA?.name
  const sectionAId = sectionA?.id
  const sectionBName = sectionB?.name
  const sectionBId = sectionB?.id

  const filteredMetrics = Array.isArray(metrics)
    ? metrics.filter(({ id }) => !['daily_light_integral'].includes(id))
    : []

  const { liveData, isLoading } = useLiveData({
    sectionAId,
    sectionBId,
    metrics: filteredMetrics,
    currentTrial: trial,
    type
  })

  return (
    <Loader isLoading={isLoading}>
      <Grid
        className='live-view-grid'
        templateColumns='repeat(auto-fit, minmax(330px, 1fr))'
        gap={400}
        style={{
          alignItems: 'stretch'
        }}
      >
        {filteredMetrics.map(metric => {
          const sectionAData = liveData?.[`sectionA_${metric.id}`] || {}
          const sectionBData = liveData?.[`sectionB_${metric.id}`] || {}

          return (
            <Box key={metric.id} style={{ height: '100%' }}>
              <Card
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Slot name='body'>
                  <Box
                    style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '16px'
                    }}
                  >
                    <FlexV2 alignCrossAxis='center' axisGap={200}>
                      <Text
                        size={200}
                        fontWeight={600}
                        variant='page'
                        tone={800}
                      >
                        {metric.title}
                      </Text>
                    </FlexV2>

                    <FlexV2 axisGap={400} style={{ flex: 1 }}>
                      <MetricValue
                        label={sectionAName}
                        value={sectionAData.average}
                        min={sectionAData.min}
                        max={sectionAData.max}
                        unit={metric.unitLabel}
                      />
                      <MetricValue
                        label={sectionBName}
                        value={sectionBData.average}
                        min={sectionBData.min}
                        max={sectionBData.max}
                        unit={metric.unitLabel}
                      />
                    </FlexV2>
                  </Box>
                </Slot>
              </Card>
            </Box>
          )
        })}
      </Grid>
    </Loader>
  )
}

export default LiveView
